import React, { useRef } from "react";
import "../mobile.css";

/**
 * "Take a photo": opens the phone's camera straight away (accept="image/*" + capture), with the
 * photo library still one tap away on iPhone. Hands the chosen File(s) to onPick; uploading
 * is the caller's (and goes through the same shared action the desktop page uses).
 */
export default function PhotoButton({
  onPick,
  label = "Take a photo",
  icon = "fa-camera",
  multiple = false,
  capture = "environment",
  disabled = false,
  busy = false,
  className = "btn btn-primary btn-lg w-100",
  testId = "photo-button",
}) {
  const inputRef = useRef(null);

  const onChange = (e) => {
    const files = Array.from(e.target.files || []);
    // Reset so taking the same photo again still fires onChange.
    e.target.value = "";
    if (files.length && onPick) onPick(multiple ? files : files[0]);
  };

  return (
    <>
      <button
        type="button"
        className={className}
        disabled={disabled || busy}
        onClick={() => inputRef.current && inputRef.current.click()}
        data-testid={testId}
      >
        {busy ? (
          <span className="spinner-border spinner-border-sm me-2" aria-hidden="true" />
        ) : (
          <i className={`fas ${icon} me-2`} aria-hidden="true" />
        )}
        {busy ? "Uploading…" : label}
      </button>
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        capture={capture || undefined}
        multiple={multiple}
        onChange={onChange}
        className="jq-visually-hidden"
        tabIndex={-1}
        aria-hidden="true"
        data-testid={`${testId}-input`}
      />
    </>
  );
}
